import { io, Socket } from 'socket.io-client';
import { useAuthStore } from '../stores/auth.store';

const API_URL = import.meta.env.VITE_API_URL || '';
// events.gateway.ts declares @WebSocketGateway({ namespace: '/events' }) —
// a Socket.IO namespace is addressed via the connection URL itself (not a
// client option), so this must be appended here to actually land on that
// gateway rather than the default "/" namespace.
const EVENTS_SOCKET_URL = `${API_URL}/events`;

let socket: Socket | null = null;

/**
 * Lazy singleton — the whole app shares one connection to the /events
 * namespace rather than each component opening its own. socket.io-client
 * has been a listed dependency since the backend gateway was built, but
 * nothing on the frontend used it until the live-screenshot feature
 * needed a way to receive a push notification (see screenshot:new,
 * screenshotRequest:update in events.gateway.ts) instead of polling.
 */
export function getSocket(): Socket {
  if (socket) return socket;

  socket = io(EVENTS_SOCKET_URL, {
    transports: ['websocket', 'polling'],
    // A function (not a static value) so a reconnect after a token
    // refresh picks up the *current* access token rather than the one
    // that was live when the socket first connected.
    auth: (cb) => cb({ token: useAuthStore.getState().accessToken }),
    autoConnect: false,
  });

  return socket;
}

export function connectEventsSocket(): Socket {
  const base = getSocket();
  if (!base.connected) {
    base.connect();
  }
  return base;
}
